<template>
  <div
    v-if="isDownloading"
    @mouseover="handleMouseOverDownload"
    @mouseleave="handleMouseLeaveDownload"
  >
    <v-tooltip bottom>
      <v-btn
        class="download-btn"
        slot="activator"
        color="grey lighten-3"
        icon
        @click="handleClickCancelDownload"
      >
        <v-icon v-if="isMouseHoverDownload">clear</v-icon>
        <v-icon v-else>get_app</v-icon>
        <svg v-if="!isMouseHoverDownload" class="progress-circle indefinite" width="50" height="50">
          <g transform="rotate(-90,25,25)">
            <circle class="bg" r="20" cx="25" cy="25" fill="none" />
            <circle class="progress" r="20" cx="25" cy="25" fill="none" />
          </g>
        </svg>
      </v-btn>
      <span>{{ $t('records.cancel_export_exceeds_order') }}</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'Downloading',
  data() {
    return {
      isMouseHoverDownload: false
    }
  },
  computed: {
    isDownloading() {
      return this.$store.getters.isLoadingExceedsOrder
    }
  },
  methods: {
    handleMouseOverDownload() {
      this.isMouseHoverDownload = true
    },
    handleMouseLeaveDownload() {
      this.isMouseHoverDownload = false
    },
    handleClickCancelDownload() {
      this.$store.dispatch('cancelExportExceedsOrder')
    }
  }
}
</script>
<style lang="scss" scoped>
.download-btn {
  margin-right: 8px !important;
  position: relative;
}

// indefinite
.progress-circle {
  position: absolute;
}

.progress-circle.indefinite .progress {
  stroke: #f37336;
  stroke-width: 2;
  stroke-dashoffset: 0;
  stroke-dasharray: 63 188;
  animation: progress-indef 2s linear infinite;
}

.progress-circle.indefinite .bg {
  stroke: #eee;
  stroke-width: 2;
}

@keyframes progress-indef {
  0% {
    stroke-dashoffset: 251;
  }

  100% {
    stroke-dashoffset: 0;
  }
}
</style>
